export default __webpack_public_path__ + "static/media/product.df177b36.webp";